
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "lucide-react";

const customResources = [
  {
    title: "Mike Cohn's Guide to Story Points",
    url: "https://www.mountaingoatsoftware.com/blog/what-are-story-points",
    description: "Detailed explanation of story points estimation from the creator of the concept."
  },
  {
    title: "Atlassian: Estimation Techniques",
    url: "https://www.atlassian.com/agile/project-management/estimation",
    description: "Comprehensive guide to agile estimation techniques."
  },
  {
    title: "Planning Poker Blog",
    url: "https://www.planningpoker.com/blog/",
    description: "Resources and articles about Planning Poker and agile estimation."
  }
];

export const EstimationResources = () => {
  return (
    <Card className="bg-white dark:bg-gray-900 border-blue-100 dark:border-gray-800">
      <CardHeader>
        <CardTitle className="text-xl text-blue-700 dark:text-gray-300">Helpful Resources</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {customResources.map((resource, index) => (
            <a 
              key={index} 
              href={resource.url} 
              target="_blank" 
              rel="noreferrer"
              className="flex items-start gap-3 p-3 rounded-md hover:bg-blue-50 dark:hover:bg-gray-800/30 transition-colors"
            >
              <Link className="h-5 w-5 text-blue-600 dark:text-gray-400 flex-shrink-0 mt-0.5" />
              <div>
                <h3 className="font-medium text-blue-800 dark:text-gray-300 mb-1">{resource.title}</h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">{resource.description}</p>
              </div>
            </a>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
